/** Places a layout's direct child image between its assigned title and paragraph on mobile. */
const mobileQuery = window.matchMedia('(max-width: 749px)');
const titleSelector = '.text-block--mobile-media-role-title';
const paragraphSelector = '.text-block--mobile-media-role-paragraph';

/** @type {WeakMap<HTMLElement, Comment>} */
const imagePlaceholders = new WeakMap();

function restoreImages() {
  for (const image of document.querySelectorAll('.image-block')) {
    if (!(image instanceof HTMLElement)) continue;

    const placeholder = imagePlaceholders.get(image);
    if (placeholder?.parentNode) {
      placeholder.replaceWith(image);
      imagePlaceholders.delete(image);
      image.classList.remove('image-block--mobile-relocated');
    }
  }
}

function arrangeImages() {
  if (!mobileQuery.matches) {
    restoreImages();
    return;
  }

  const titles = document.querySelectorAll(titleSelector);
  const movedImages = new Set();
  for (const title of titles) {
    if (!(title instanceof HTMLElement)) continue;

    const textGroup = title.parentElement;
    const paragraph = textGroup?.querySelector(paragraphSelector);
    if (!(paragraph instanceof HTMLElement)) continue;

    let layout = title.parentElement;
    let image = null;

    while (layout) {
      if (layout.classList.contains('layout-panel-flex')) {
        const layoutImage = Array.from(layout.children).find((child) => child.classList.contains('image-block'));
        if (layoutImage instanceof HTMLElement) {
          image = layoutImage;
          break;
        }
      }
      layout = layout.parentElement;
    }

    if (!(image instanceof HTMLElement)) continue;
    if (movedImages.has(image)) continue;

    const placeholder = imagePlaceholders.get(image);
    if (placeholder && !layout?.contains(placeholder)) {
      imagePlaceholders.delete(image);
    }

    if (!imagePlaceholders.has(image)) {
      const originalPosition = document.createComment('mobile-image-position');
      image.before(originalPosition);
      imagePlaceholders.set(image, originalPosition);
    }

    paragraph.before(image);
    image.classList.add('image-block--mobile-relocated');
    movedImages.add(image);
  }
}

function scheduleImageArrangement() {
  window.requestAnimationFrame(arrangeImages);
}

mobileQuery.addEventListener('change', scheduleImageArrangement);
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleImageArrangement);
} else {
  scheduleImageArrangement();
}
document.addEventListener('shopify:section:load', scheduleImageArrangement);
document.addEventListener('shopify:section:reorder', scheduleImageArrangement);
document.addEventListener('shopify:block:select', scheduleImageArrangement);
document.addEventListener('shopify:block:deselect', scheduleImageArrangement);
